module.exports = __webpack_public_path__ + "img/kep4-1.59d725c0.jpg";